export default {
  textTitle: "Рассчитать стоимость<br/> доставки по России",
  textTitleText: "Любым удобным способом. Зона покрытия — вся Россия",
  textFrom: 'Откуда',
  textFields: {
    in: {
      label: 'Куда',
      placeholder: 'Екатеринбург'
    },
    weight: {
      label: 'Вес, кг',
      placeholder: '1'
    },
    length: {
      label: 'Габариты, cм',
      placeholder: '10'
    },
    inshprice: {
      label: 'Оценочная стоимость, р.',
      placeholder: '1000'
    },
    price: {
      label: 'Наложенный платеж, р.',
      placeholder: '1000'
    },
  },
  textButton: 'Подобрать тариф',
  optionsFrom: [
    { label: 'Москва', value: 0 },
    { label: 'Санкт-Петербург', value: 1 },
  ],
}
